import React from 'react';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { isEmpty } from 'shared/utils/object';
import styled, { useTheme } from 'styled-components';
import NotificationBadge from '../../../../components/NotificationBadge/NotificationBadge';

const SocialHeaderTab = ({ onClick, title, activeTab, count }) => {
  const { SocialHeaderTab } = useTheme();
  return (
    <>
      <BackgroundActive
        theme={SocialHeaderTab.BackgroundImage}
        src={assetSource(ASSET_KEY.TAB_FRONT)}
        activeTab={activeTab}
      />
      <BackgroundInactive
        theme={SocialHeaderTab.BackgroundImage}
        src={assetSource(ASSET_KEY.TAB_BACK)}
        activeTab={activeTab}
      />
      <Clickable onClick={onClick}>
        <Title>{title}</Title>
        {!isEmpty(count) && <NotificationBadge count={count} theme={BadgeStyles} />}
      </Clickable>
    </>
  );
};

export default SocialHeaderTab;

const BackgroundActive = styled.img`
  width: 85%;
  height: 92%;
  position: absolute;
  z-index: 1;
  ${({ theme }) => theme}
  ${({ activeTab }) => activeTab && `transform: rotateY(180deg);`}
`;

const BackgroundInactive = styled.img`
  width: 85%;
  height: 92%;
  position: absolute;
  ${({ theme }) => theme}
  ${({ activeTab }) => activeTab && `transform: rotateY(180deg);`}
`;

const Clickable = styled.div`
  z-index: 10;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 5.6rem;
  transform: translateY(-15px);
  ${({ theme }) => theme.breakpoints.down('xl')} {
    min-height: 4.6rem;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    min-height: 4rem;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    min-height: 5rem;
  }
  ${({ theme }) => theme.screens.devices(['mobile-browser', 'mobile-standalone', 'tablet-browser', 'tablet-standalone']) && 'min-height: 4rem;'}
`;

const Title = styled.h4`
  margin: 0 1vw;
  font-size: 1.8rem;
  background: linear-gradient(to bottom, rgb(247, 238, 209) 35%, rgb(223, 195, 111) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
  text-stroke: 0.5px #000;
  -webkit-text-stroke: 0.5px #000;
  text-shadow: -1px 1px 15px rgba(223, 195, 111, 0.5);
  text-transform: uppercase;
`;

const BadgeStyles = {
  position: 'relative',
};

